import React, { useEffect, useRef, useState } from 'react';
import PageContainer from '../../components/PageContainer';
import MainContent from '../../components/MainContent';
import PageTitle from '../../components/Common/PageTitle/PageTitle';
import ActionDropdownItem from '../../components/Common/PageTitle/ActionDropdownItem';
import ActivityLoader from '../../components/Common/ActivityLoader';
import Notification from '../../components/Common/Notification';
import JournalEntryTable from '../../components/JournalEntryTable';
import { useJournal } from '../../DataStore/JournalContext';
import Pagination from '../../components/Common/Pagination';
import AlertDateSelector from '../../components/Report/AlertDateSelector';
import printContent from '../../util/araknerdlib';
import functions from '../../util/functions';


const JournalPage = () => {
    const {JournalList, getTransactions, setCurrentPage, metaData, dispatch, refresh, fetchedPeriod} = useJournal();
    const [showAlert, setShowAlert] = useState(false);
    const statementRef = useRef(); // Ref to enclose statement content for printing

    useEffect(()=>{
        getTransactions();
    }, [])

     const handleConfirmDateRange = async (range) => {
        dispatch({ type: 'dateRange', payload: range });
        setCurrentPage(1);
        await getTransactions(true, range);
      };


    const PageActions = ()=>(<>
        <ActionDropdownItem iconClass="fa fa-calendar-alt text-success" label="Filter Date Range" onClick={()=>setShowAlert(true)}/>
        <ActionDropdownItem iconClass="fa fa-sync" label="Refresh" onClick={refresh}/>
        <ActionDropdownItem iconClass="fa fa-print text-secondary" label="Print Entries" onClick={()=>printContent(statementRef, "Journal Entries")}/>
        </>)
    return (
        <>
        <PageContainer>
            <MainContent>
                <PageTitle
                    title="Journal Entries"
                    description={`Showing all journal entries for the selected financial period ${fetchedPeriod ? `(${ functions.formatDate(fetchedPeriod.opening_date)} to ${functions.formatDate(fetchedPeriod.closing_date)})` : ''}`}
                    iconClass="fa fa-book"
                    PageActions={PageActions}
                    sticky={true}
                    Pagination={metaData ? <Pagination
                                    metaData={metaData}
                                    onPageChange={(page) => setCurrentPage(page)}
                            /> : <></>}
                />

                <div className="card mb-3">
                    <div className="card-body">
                   
                        <div ref={statementRef}>
                            {Array.isArray(JournalList) && JournalList.map((item, key)=>
                            <JournalEntryTable key={key} {...item} />
                            )}
                        </div>
                        {JournalList === "404" && <Notification type="info" message="No journals found for this financial period" />}
                        {!JournalList && <ActivityLoader width={20} />}
                    </div>
                </div>
            </MainContent>
        </PageContainer>
         <AlertDateSelector
            show={showAlert}
            onClose={() => setShowAlert(false)}
            onConfirm={handleConfirmDateRange}
        />
        </>
    );
};

export default JournalPage;
